import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createRef, useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { StationInfoBox } from "./StationInfoBox";
import { StationsList, StationsListContainer } from "./GoogleMap.styles";
export var MobileStationsList = function(param) {
    var selectStation = param.selectStation, selectedStation = param.selectedStation, stations = param.stations, mapWidth = param.mapWidth;
    var refs = stations.reduce(function(acc, station) {
        acc[station.id] = /*#__PURE__*/ createRef();
        return acc;
    }, {});
    useEffect(function() {
        var ref;
        if (!selectedStation) return;
        var ref1 = refs[selectedStation];
        (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
            block: "start"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedStation
    ]);
    var map = useMap();
    return /*#__PURE__*/ _jsx(StationsListContainer, {
        width: mapWidth,
        children: /*#__PURE__*/ _jsx(StationsList, {
            children: stations.map(function(station) {
                var handleClick = function() {
                    map === null || map === void 0 ? void 0 : map.setCenter({
                        lat: station.latitude,
                        lng: station.longitude
                    });
                    map === null || map === void 0 ? void 0 : map.setZoom(13);
                    selectStation(station.id, station.stationKind);
                };
                return /*#__PURE__*/ _jsx(StationInfoBox, {
                    station: station,
                    ref: refs[station.id],
                    onClick: handleClick,
                    selected: selectedStation === station.id
                }, station.id);
            })
        })
    });
};
